import { createRoutine } from 'redux-saga-routines';

export const routine = createRoutine('SIGNIN_FORM/LOGIN_AND_PASSWORD');
